import React from 'react'
import vscode from './Images/Skills/vscode.png'
import unity from './Images/Skills/unity.png'
import csharp from './Images/Skills/csharp.png'
import blender from './Images/Skills/blender.png'
import java from './Images/Skills/java.png'
import js from './Images/Skills/js.jpeg'
import html from './Images/Skills/html.png'
import css from './Images/Skills/css.png'

const Skills = () => {
  return (
    <>
        <div className="skills">
            <div className="flex">
                <img src={vscode} alt="" />
                <img src={unity} alt="" />
                <img src={csharp} alt="" />
                <img src={blender} alt="" />
                <img src={java} alt="" />
                <img src={js} alt="" />
                <img src={html} alt="" />
                <img src={css} alt="" />
            </div>
            <div className="item">
                <div className="title">Skills</div>
                <ol className="skill">
                    <li>C#</li>
                    <li>Java</li>
                    <li>Css3</li>
                    <li>Javascript</li>
                    <li>Html</li>
                    <li>Blender</li>
                    <li>Unity</li>
                    <li>Spark Ar</li>
                </ol>
            </div>
        </div>
    </>
  )
}

export default Skills